/**
 * 더 묻기 답 본문을 읽기 쉬운 블록으로 — 서버 프롬프트가 요구하는 고정 구조("요약:" 한 줄 → "근거:" 항목 → "확인할 것:" 항목)를
 * 그대로 살리고, 구조가 없는 옛 답·다른 모델의 답은 문장 두 개씩 문단으로 나눈다. 2026-09-14 사용자: "LLM 출력이 정리가 안 돼 난해하다".
 * 블록: {kind:"summary"|"section"|"bullet"|"para", text, label?}
 */
const SECTION = /^(요약|결론|근거|확인할 것|확인 사항|주의|참고|다음 질문)\s*[:：]\s*(.*)$/;
const BULLET = /^(?:[-•·▪◦]|\d+[.)])\s+(.*)$/;

function sentences(text) {
  const t = String(text || "").replace(/\s+/g, " ").trim();
  if (!t) return [];
  const out = []; let buf = "";
  for (const piece of t.split(/(?<=[.!?。])\s+(?=[가-힣A-Za-z0-9("'\u201c])/)) { buf = piece.trim(); if (buf) out.push(buf); }
  return out;
}

export function answerBlocks(text) {
  // 2026-10-04: GPT 는 줄바꿈을 JSON 안에서 한 번 더 escape 해 글자 그대로 "\n"(역슬래시+n)이 온다 — 실제 줄바꿈으로 바꾼다
  const raw = String(text || "").replace(/\\n/g, "\n").replace(/\r\n?/g, "\n").trim();
  if (!raw) return [];
  const lines = raw.split("\n").map((l) => l.trim()).filter(Boolean);
  const structured = lines.some((l) => SECTION.test(l) || BULLET.test(l));
  if (!structured) {
    const s = sentences(raw);
    if (s.length <= 2) return [{ kind: "para", text: raw }];
    const out = [];
    for (let i = 0; i < s.length; i += 2) out.push({ kind: "para", text: s.slice(i, i + 2).join(" ") });
    return out;
  }
  const out = [];
  for (const line of lines) {
    const sec = line.match(SECTION);
    if (sec) {
      const label = sec[1] === "결론" ? "요약" : sec[1] === "확인 사항" ? "확인할 것" : sec[1];
      if (label === "요약") { out.push({ kind: "summary", text: sec[2].trim() }); continue; }
      out.push({ kind: "section", label });
      if (sec[2] && sec[2].trim()) out.push({ kind: "bullet", text: sec[2].trim() });
      continue;
    }
    const b = line.match(BULLET);
    if (b) { out.push({ kind: "bullet", text: b[1].trim() }); continue; }
    out.push({ kind: "para", text: line });
  }
  return out;
}
